import {
  HistoryItemAgent,
  PricesAccordionTab,
  PricesTabType,
} from 'store/state/selectors/insights/prices';
import { PaginationType } from 'ds/components/pagination';
import { PoiId } from 'utils/entities';
import { IGetPublicRealEstateAgentsByIdsResponseItem, IGetPublicRealEstateOfficesByIdsResponseItem } from 'store/sagas/apiService/types';
import { setAuthModal } from 'store/state/app/actions';


export interface ColumnRendererProps<T> {
  item: T;
  isExpanded?: boolean;
  isMobile?: boolean;
  tabId?: PricesTabType;
  isAgent?: boolean;
}

export enum PricesTableColumn {
  Date = 'date',
  Action = 'action',
  Price = 'price',
  PricePerSqFeet = 'pricePerSqFeet',
  Source = 'source',
  Unit = 'unit',
  Address = 'address',
  SqFt = 'sqFt',
  Beds = 'beds',
  Baths = 'baths',
  Floor = 'floor',
  Type = 'type',
  Buyer = 'buyer',
  Seller = 'seller',
  Agent = 'agent',
  Year = 'year',
  Distance = 'distance',
  ProjectName = 'projectName',
}

export const genericColConfig = {
  align: 'right',
  width: '10%',
  gap: 16,
};

export interface HistoryTableProps {
  setActivePoiIds: (ids: string[]) => void;
  setActiveRecordIndex: (id: string[]) => void;
  setPricesLastExpandedRow: (saleId: string) => void;
  activeRecordIndex: string[];
  isAgentConsoleUser?: boolean;
  currentBulletinId: PoiId | string;
  isAddressMasked: boolean;
  activeTab: PricesTabType;
  isMobile: boolean;
  tab: PricesAccordionTab;
  visibleRowsMobile: number;
  visibleRowsDesktop: number;
  paginationType?: PaginationType;
  projectId: string;
  projectIds: string[];
  isProjectPage?: boolean;
  dealsAgentsData?: IGetPublicRealEstateAgentsByIdsResponseItem[];
  dealsOfficesData?: IGetPublicRealEstateOfficesByIdsResponseItem[];
  isConnectedUser?: boolean;
  onSetAuthModal?: typeof setAuthModal;
}

export const EMPTY_COL_CHAR = '-';

export const filterItemData = (
  item: HistoryItemAgent,
  approvedAgents: IGetPublicRealEstateAgentsByIdsResponseItem[],
  approvedOffices: IGetPublicRealEstateOfficesByIdsResponseItem[],
  isStrictOfficeCheck?: boolean
) => {
  if (item) {
    const approvedAgent = approvedAgents && approvedAgents.find(agent => agent.agentId === item.agentId);
    const approvedOffice = approvedOffices && approvedOffices.find(office => office.officeId === item.agencyId);

    const isApprovedAgent = Boolean(approvedAgent);
    const isApprovedOffice = Boolean(approvedOffice);

    if (isStrictOfficeCheck && !isApprovedOffice) return null;

    if (isApprovedAgent || isApprovedOffice) {
      return {
        ...item,
        hideDealsOnPublicSite: false,
        ...(isApprovedAgent ? {
          agentName: approvedAgent.name,
          agentImageUrl: approvedAgent.iconUrl,
        } : {
          agentName: undefined,
          agentImageUrl: undefined,
          agentId: undefined,
        }),
        ...(isApprovedOffice ? {
          agencyName: approvedOffice.officeName,
          agencyImageUrl: approvedOffice.iconUrl,
          hideDealsOnPublicSite: approvedOffice.hideDealsOnPublicSite,
        } : {
          agencyId: undefined,
          agencyImageUrl: undefined,
          agencyName: undefined,
        }),
      };
    }
  }

  return null;
};
